require("../scss/maintenance.scss");

require("./localize-html.js");
require("../js/reloader.js");
